import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EWorkshopModel } from '../models/e-workshop.model';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs';
import { AuthService } from '../../../core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class EWorkshopService {
  tickVideoWatchTime(workshopId: number, id: number, arg0: number) {
    return this.http.post<any>(
      `${this.apiUrl}${workshopId}/videos/${id}/spent-time/`,
      {
        total_time: arg0,
      },
    );
  }
  apiUrl: string = environment.baseApi + 'trainings/e-workshops/';
  authService: AuthService = inject(AuthService);
  constructor(private http: HttpClient) {}

  getWorkshops(page: number = 1) {
    return this.http.get<any>(this.apiUrl, {
      params: {
        page: page,
      },
    });
  }

  getWorkshop(id: number) {
    return this.http.get<EWorkshopModel>(this.apiUrl + id + '/');
  }

  // /trainings/e-workshops/6183/comments/
  getComments(page: number = 1, workshopId: number) {
    return this.http.get<any>(`${this.apiUrl}${workshopId}/comments/`, {
      params: {
        page: page,
      },
    });
  }

  addComment(workshopId: number, comment: string) {
    return this.http.post<any>(`${this.apiUrl}${workshopId}/comments/add/`, {
      body: comment,
    });
  }

  getVideoProgress(workshopId: number, videoId: number) {
    return this.http.get<{ last_position: number }>(
      `${this.apiUrl}${workshopId}/videos/${videoId}/progress/`,
    );
  }

  /**POST {{ROOT}}/trainings/e-workshops/202/videos/22/progress/update/
Authorization: Bearer {{auth_token}}
Content-Type: application/json

{
  "new_session": true,
  "from_position": 250,
  "to_position": 1000
} */

  updateVideoProgress(
    workshopId: number,
    videoId: number,
    newSession: boolean,
    fromPosition: number,
    toPosition: number,
  ) {
    return this.http.post<any>(
      `${this.apiUrl}${workshopId}/videos/${videoId}/progress/update/`,
      {
        new_session: newSession,
        from_position: fromPosition,
        to_position: toPosition,
      },
    );
  }
  updateVideoProgressKeepAlive(
    workshopId: number,
    videoId: number,
    newSession: boolean,
    fromPosition: number,
    toPosition: number,
  ) {
    const endpoint = `${this.apiUrl}${workshopId}/videos/${videoId}/progress/update/`;
    const payload = {
      new_session: newSession,
      from_position: fromPosition,
      to_position: toPosition,
    };
    fetch(endpoint, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.authService.user.value?.token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      keepalive: true,
    }).then();
  }
}
